module.exports = __webpack_public_path__ + "static/media/Inky_DudleyBachrach.c96cb286.png";